import { useSyncExternalStore } from "react";
import { apiRequest, type Envelope } from "../api/client";
import type { Session } from "../api/models";
import { AiChannel } from "../communications/ai-availability";
import { assertHealthy, type PatronDetail } from "./assist-logic";

// `pillars-assist.service.ts` AND THE ONE `in-play.service.ts` CALL THE PANEL MAKES, VERBATIM.
// EVERY AI CALL GOES TO THE CORE API, NEVER TO AN AI PROVIDER.

// `SendPrompt`
export const sendPrompt = (body: unknown, signal: AbortSignal) => apiRequest<unknown>("/pillars-assist/send-prompt", { method: "POST", body, signal });

// `Health`, AS THE PROBE READS IT: A BODY SAYING `healthy: false` COUNTS AS A FAILURE. IT TAKES
// NO ABORT SIGNAL BECAUSE THE RECONNECT POLL REUSES IT LONG AFTER THE PROMPT THAT FAILED
export const healthProbe = () => apiRequest<unknown>("/pillars-assist/health").then(assertHealthy);

// `GetPatronDetail`
export const getPatronDetail = (patronId: number | undefined) => apiRequest<Envelope<PatronDetail | null>>(`/patron/get-patron/${patronId}`);

// `InPlayService.GetActiveSession`: A NULL `data` MEANS THE SESSION ENDED
export const getActiveSession = (body: { session_id?: number; location?: string }) => apiRequest<Envelope<Session | null>>("/ht/get-active-session", { method: "POST", body });

// THE "pillars-assist" CHANNEL OF `AiAvailabilityService`: THE COMMUNICATIONS PORT'S `AiChannel`
// CLASS, ITS OWN INSTANCE, SO AN OUTAGE ON ONE SURFACE DOES NOT DISABLE THE OTHER (AS ANGULAR
// KEEPS ONE STATE PER CHANNEL)
export const pillarsAssistAi = new AiChannel();

export function usePillarsAssistAvailable(): boolean {
  return useSyncExternalStore(pillarsAssistAi.subscribe, () => pillarsAssistAi.isAvailable);
}
